/* src/app/modules/print-cards/components/cards/card-content/shared/components/shelf-talker-pricing/shelf-talker-pricing.component.scss */
/*# sourceMappingURL=shelf-talker-pricing.component.css.map */
